import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CrewMember } from 'app/features/flights/flight-detail/model/crew-member';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import { RequestState, RequestStatus } from '@shared/models/request-state';
import { AppService } from 'app/app.service';
import { SkeletonModule } from 'primeng/skeleton';
import { FlightdetailService } from '../service/flightdetail.service';

@Component({
    selector: 'app-crew-contact-info',
    imports: [
        CommonModule,
        SkeletonModule
    ],
    templateUrl: './crew-contact-info.component.html',
    styleUrl: './crew-contact-info.component.scss'
})
export class CrewContactInfoComponent {

  crewMemberDetails$ = this.getCrewMemberContactInfo();

  phoneIconLight = '/assets/icons/com/phoneIconLight.svg';
  phoneIconDark = '/assets/icons/com/phoneIconDark.svg';
  telephoneIconLight = '/assets/icons/com/telephoneIconLight.svg';
  telephoneIconDark = '/assets/icons/com/telephoneIconDark.svg';
  smsIconLight = '/assets/icons/com/smsIconLight.svg';
  smsIconDark = '/assets/icons/com/smsIconDark.svg';
  emailIconLight = '/assets/icons/com/emailIconLight.svg';
  emailIconDark = '/assets/icons/com/emailIconDark.svg';

  // Disabled or Offical Use Only Icons
  emailIconNone = '/assets/icons/com/emailIconNone.svg';
  phoneIconNone = '/assets/icons/com/phoneIconNone.svg';
  smsIconNone = '/assets/icons/com/smsIconNone.svg';
  telephoneIconNone = '/assets/icons/com/telephoneIconNone.svg';



  constructor(
    public appService: AppService,
    private flightDetailService: FlightdetailService
  ) { }

  
  getCrewMemberContactInfo(): Observable<RequestState<CrewMember>> {
      return combineLatest([
        this.flightDetailService._requestedEmpNum$,
        this.flightDetailService.intiatorEmpNum$,
      ]).pipe(
        switchMap(([requested, initiator]) => {
          const cacheId = `reqDetail${requested}`
          return this.flightDetailService.getCrewMemberDetails(
            requested,
            initiator,
            cacheId
          ).pipe(
            map((data) => {
  
              if (!data || !data.response || data.hasError || data.isLoading) {
                
                return new RequestState<CrewMember>(
                  RequestStatus.IsCompleteNoResponse,
                )
              }
  
              const crewMember = {
                timestamp: data.response?.timestamp || '',
                name: data.response?.name || '',
                seniority: data.response?.seniority || 0,
                employeeNumber: data.response?.employeeNumber || '',
                bidStatus: data.response?.bidStatus || '',
                apaStatus: data.response?.apaStatus || '',
                seat: this.extractSeatPosition(data.response?.bidStatus || ''),
                primaryEmail: data.response?.primaryEmail || 'unknown',
                telephone: data.response?.telephone || 'unknown',
                cell: data.response?.cell || 'unknown'
              }
              return new RequestState<CrewMember>(
                RequestStatus.IsCompleteWithResponse,
                crewMember
              )
            })
          )
        })
      );
    }

    /** Strip CA or FO from 4 part, if needed later
   * Add XA|XO for Check Airman or
   * add FE for Flight Engineer
   * But since this is current status there should
   * not be anything other than CA|FO
   */
  extractSeatPosition(bidStatus: string): string {
    const match = bidStatus.match(/(?<=\/)CA|FO(?=\/)/);
    return match ? match[0] : '';
  }

}
